



<template lang="jade">

	div.app-canvas
		router-view(name="canvas")

</template>



<script>

	let $cmp = {
		name : 'app-canvas'
	}

	export default $cmp

</script>



<style lang="stylus">

	.app-canvas
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		overflow hidden

</style>



// WEBPACK FOOTER //
// src/app-canvas.vue